export const Colors = {
  greyLighter: '#F0F0F0'
}